/**
 * Utility functions for the application.
 */
import config from "./config.js";
import * as ui from "./ui.js";
import * as apihandler from "./api-handler.js";
import * as events from "./events.js";
import * as canvasRender from "./canvas-render.js";
import * as sw from './sw.js';
const navigator = window.navigator;
const location = window.location;
const sessionStorage = window.sessionStorage;

let ct = config.ct;
const imageDesigned = document.querySelector(".image-designed");
const messageDiv = document.querySelector(".message");
const imageContainer = document.querySelector(".images-container");

/**
 * 
 * @param {any} input 
 * @returns 
 */
export function validateLength(input) {

  if (!input.maxLength || input.maxLength <= 0) return; // Exit if maxLength is not set

  const maxLength = input.maxLength;
  const warning = input.nextElementSibling; // Get the warning div after the input

  if (input.value.length >= maxLength) {
    input.value = input.value.slice(0, maxLength); // Trim excess text
    warning.classList.add("show");
    input.classList.add("warning-border");

    if ("vibrate" in navigator) {
      navigator.vibrate(100); // Mobile vibration for better UX
    }

    window.setTimeout(() => {
      warning.classList.remove("show");
      input.classList.remove("warning-border");
    }, 2000);
  }
}
/**
 * isFakeUserAgent - Detects if the user agent is likely fake or from a bot.
 * @return {boolean} True if the user agent is fake, false otherwise.
 */
export function isFakeUserAgent() {
  const ua = navigator.userAgent.toLowerCase();
  const knownFakePatterns = [
    "curl", "python", "okhttp", "dalvik", "winhttp", "httpclient",
    "node-fetch", "wget", "axios", "request", "scrapy", "phantomjs",
    "headlesschrome", "puppeteer", "java/", "go-http-client",
    "libwww-perl", "mediapartners-google"
  ];
  if (knownFakePatterns.some(p => ua.includes(p))) {
    return true;
  }
  // Suspicious UA structure
  if (ua.length < 20 || ua === "mozilla/5.0") {
    return true;
  }
  // Browser feature test
  let hasWebGL = false;
  try {
    const c = document.createElement("canvas");
    hasWebGL = !!(c.getContext("webgl") || c.getContext("experimental-webgl"));
  } catch (ex) { console.log(ex) }
  if (!hasWebGL) return true;
  // Basic modern features
  if (!navigator.cookieEnabled) return true;

  return false;
}
/**
 * Parses the Cloudflare response into an object.
 * @param {string} text 
 * @returns {object}
 */
export function parseCloudflareResponse(text) {
  return text.trim().split("\n").reduce((obj, pair) => {
    let [key, value] = pair.split("=");
    obj[key] = value;
    return obj;
  }, {});
}
/**
 * Calculates the difference in hours between two dates.
 * @param {date} dt2 
 * @param {Date} dt1 
 * @returns {number} difference in hours
 */
export function diff_hours(dt2, dt1) {
  let diff = (dt2 - dt1) / 1000;
  diff /= 60 * 60;
  return Math.abs(Math.round(diff));
}

/**
 * Checks if the user has creation attempts left based on cookies.
 * @returns {void} if not exists cookie create a new one
 */
export function checkFlagDateExists() {

  let _flag = getCookie("_flag");
  if (_flag == undefined || _flag == "") {
    let d = new Date();
    d.setTime(d.getTime() + config.cookieHours * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = "_flag" + "=" + d + ";" + expires + ";path=/";
  }
}
/**
 *  Sets a cookie with expiration based on the _flag cookie.
 *  @param {string} cname - The name of the cookie to set.
 *  @param {string} cvalue - The value of the cookie to set.
 *  */
export function setCookieWithFlagExpiry(cname, cvalue) {
  checkFlagDateExists();
  let _flag = getCookie("_flag");

  if (_flag !== undefined && _flag !== null) {
    let flagDate = new Date(_flag); // Convert to Date object
    let utcExpires = "expires=" + flagDate.toUTCString(); // Convert to UTC format
    document.cookie = cname + "=" + cvalue + "; " + utcExpires + "; path=/";
    // const timestamp = new Date(flagDate.toUTCString()).getTime();
    // setToLocalStorage(cname, cvalue, 1, timestamp);
    // get the function caller

    // const stack = new Error().stack;
    // console.log(stack); // full stack trace
    // const callerLine = stack.split('\n')[2]; // third line is usually the caller
    // const callerName = callerLine.trim().split(' ')[1] || 'anonymous';
    // console.log('setCookie Caller is:', callerName);
  }
}
export function setLocalStorageWithFlagExpiry(cname, cvalue) {
  checkFlagDateExists();
  let _flag = getCookie("_flag");

  if (_flag !== undefined && _flag !== null) {
    let flagDate = new Date(_flag); // Convert to Date object
    // let utcExpires = "expires=" + flagDate.toUTCString(); // Convert to UTC format
    // document.cookie = cname + "=" + cvalue + "; " + utcExpires + "; path=/";
    const timestamp = new Date(flagDate.toUTCString()).getTime();
    setToLocalStorage(cname, cvalue, 1, timestamp);
  }
}
/**
 * sets a cookie by hours
 * @param {string} cname 
 * @param {string} cvalue 
 * @param {int} exhours (in hours)
 */
export function setCookie(cname, cvalue, exhours) {
  const d = new Date();
  d.setTime(d.getTime() + exhours * 60 * 60 * 1000);
  setToLocalStorage(cname, cvalue, exhours);
  const expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";

  // get the function caller

  // const stack = new Error().stack;
  // console.log(stack); // full stack trace
  // // Extract caller name (works in V8: Chrome, Node.js, Edge)
  // const callerLine = stack.split('\n')[2]; // third line is usually the caller
  // const callerName = callerLine.trim().split(' ')[1] || 'anonymous';
  // console.log('setCookie Caller is:', callerName);
}
/**
 * sets a cookie by minutes
 * @param {string} cookieName 
 * @param {string} cookieValue 
 * @param {int} minutes 
 */
export function setCookieInMinutes(cookieName, cookieValue, minutes) {
  const d = new Date();
  d.setTime(d.getTime() + minutes * 60 * 1000);
  const expires = "expires=" + d.toUTCString();
  document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
}
/**
 * 
 * @param {string} name 
 * @returns {int|string|null} expect to return int if the cookie value is numeric otherwise string or null
 */
export function getCookie(name) {

  // Split cookies by semicolon to get an array of key-value pairs
  // const result = getLocalStorageValue(name)
  // console.log(`localStorage data : of ${name} : ` + result);

  var cookies = document.cookie.split(';');
  // Iterate over each key-value pair
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    // Check if this is the cookie we're looking for
    if (cookie.indexOf(name + '=') === 0) {
      // If found, extract the value
      var value = cookie.substring(name.length + 1);
      // Check if the value is numeric
      if (!isNaN(value)) {
        // console.log(`cookie data : of ${name} : ` + value);
        // If numeric, parse it as an integer and return
        return parseInt(value, 10); // Parse as base 10 integer
      } else {
        // If not numeric, return as string
        return value;
      }
    }
  }
  // If the cookie with the specified name is not found, return null
  return null;
}
/**
 * 
 * @param {string} design name
 * @returns {void} Decreases the attempt count cookie by 1 in case of error 
 */
export function handleCookiesinError(design) {
  if (!navigator.cookieEnabled) return;
  //const cookie = getCookie(design);

  const cookie = getLocalStorageValue(design);
  if (cookie === undefined || cookie === null || cookie === "") return;
  let n = parseInt(cookie, 10);
  if (isNaN(n)) return; // stop if cookie isn't a number
  n = n - 1;
  if (n < 0) n = 0; // optional: prevent negative cookies
  //setCookieWithFlagExpiry(design, n);
  setLocalStorageWithFlagExpiry(design, n);
}

/** Increases the attempt count cookie by 1
 * @param {string} cookieName 
 */
export function setAttempNumber(cookieName) {
  //if (!navigator.cookieEnabled) return;
  //const currentNumber = getCookie(cookieName);
  const currentNumber = getLocalStorageValue(cookieName);
  if (!currentNumber) {
    //setCookieWithFlagExpiry(cookieName, 1);
    setLocalStorageWithFlagExpiry(cookieName, 1);
    return;
  }
  let n = parseInt(currentNumber, 10);
  if (isNaN(n)) return;
  // setCookieWithFlagExpiry(cookieName, n + 1);
  setLocalStorageWithFlagExpiry(cookieName, n + 1);
}
/**
 * check if user is valid to create a new designs or cannot because download count exceeded
 * @returns {boolean}
 */
export function validateUsr() {
  const _totalDownload = getCookie(config.totaldowloadKey);
  if (_totalDownload != null) {
    if (parseInt(_totalDownload) >= parseInt(config.maxTotalDownloadPerCountry)) {
      return false;
    }
  }
  return true;
}
/**
 * 
 * @returns {boolean}
 */
export function isPWA() {
  return window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone === true;
}
/**
 * get value from query string by query name
 * @param {string} qname query name
 * @returns {string} query value
 */
export function getQueryValue(qname) {
  let qValue = "";
  const query = getStaticRequestParams().slice(1);
  const slaps = query.split("&");
  for (let index = 0; index < slaps.length; index++) {
    let part = slaps[index];
    let equalindex = part.indexOf("=");
    let currentqs = part.substring(0, equalindex);
    let currentqv = part.substring(equalindex + 1);
    if (currentqs.toLowerCase() == qname) {
      qValue = currentqv;
    }
  }
  return qValue;
}
/**
 * get all data from session storage as URLSearchParams and return params object
 * @returns {object}
 */
export function getDataFromSessionStorage() {
  let params = new window.URLSearchParams(window.location.search);
  const savedData = JSON.parse(sessionStorage.getItem(config.formDataKey));
  let fullQueryString = "";
  // Convert object to query string
  if (savedData != null) {
    const queryString = Object.entries(savedData)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
    fullQueryString = queryString ? `?${queryString}` : ''; // Add "?" prefix if data exists
  }
  if (fullQueryString) {
    // Remove the "?" before creating URLSearchParams
    const rawQuery = fullQueryString.startsWith('?') ? fullQueryString.slice(1) : fullQueryString;

    new window.URLSearchParams(rawQuery).forEach((value, key) => {
      params.set(key, value); // Overwrites existing keys or adds new ones
    });
    return params;
  }
}

export function getStaticRequestParams() {
  const params = getDataFromSessionStorage();
  if (params == null)
    return "";
  const title = params.get("title");
  // Return early if title is empty
  if (title !== null && title.trim() === "") {
    return;
  }
  const queries = {};
  for (const [key, value] of params.entries()) {
    queries[key] = value;
  }
  const tnamesParam = params.get('tnames');
  const tnames = tnamesParam ? tnamesParam.split(',') : [];
  const isCompoundText = tnames.length > 0;
  let paramString = "";
  let first = true;
  for (const [key, value] of Object.entries(queries)) {
    if (key === "_") continue;

    // Include everything as-is, including tnames and its values
    if (first) {
      paramString += `${key}=${value}`;
      first = false;
    } else {
      paramString += `&${key}=${value}`;
    }
  }
  // Append title if not compound text and title exists
  if (!isCompoundText && title !== null) {
    if (!first) {
      paramString += "&";
    }
    paramString += `title=${encodeURIComponent(title)}`;
  }
  return `?${paramString}`;
}
/**
 * use with php form to create hidden fields for ios devices
 * @param {int} attemps 
 * @param {boolean} shared 
 */
export function createHiddenFiledsForIos(attemps, shared) {
  let hiddenN = document.createElement("input");
  let hiddenS = document.createElement("input");
  let form = document.getElementsByTagName("form");
  hiddenN.setAttribute("type", "hidden");
  hiddenS.setAttribute("type", "hidden");
  hiddenN.setAttribute("data-val", "true");
  hiddenS.setAttribute("data-val", "true");
  hiddenN.setAttribute("name", "n");
  hiddenS.setAttribute("name", "sh");
  hiddenN.setAttribute("value", attemps);
  hiddenS.setAttribute("value", shared);
  form[0].appendChild(hiddenN);
  form[0].appendChild(hiddenS);
}
/**
 * getTodayDate get the current date in format YYYY-MM-DD
 * @returns date format of current date
 */
export function getTodayDate() {
  let today = new Date();
  let gmt = today.getUTCDate();
  return today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + gmt;
}
/**
 * getUix get unique id based on timestamp
 * @returns date timestamp
 */
export function getUix() {
  return Date.now();
}
/**
 * 
 * @returns {string} get all request params as string
 */
export function getRequestParams() {
  let params = getDataFromSessionStorage();
  // params Problems 
  let title = params.get("title");
  let tnames = "";
  if (title !== null && title.trim() === "") {
    return;
  }
  let queries = {};
  for (const [key, value] of params.entries()) {
    queries[key] = value;
  }
  let flag = true;
  let isCompoundText = false;
  if (params.has('tnames')) {
    tnames = params.get('tnames').split(",");
    isCompoundText = true;
    ct = "\"ct\":[";
    for (let i = 0; i < tnames.length; i++) {
      for (const [key, value] of Object.entries(queries)) {
        if (tnames[i] === key) {
          if (i > 0) {
            ct += ",";
          }
          ct += `{\"n\":\"${key}\",\"t\":\"${value}\"}`;
        }
      }
    }
    ct += "]";
  }
  let paramString = "";
  if (isCompoundText) {
    for (const [key, value] of Object.entries(queries)) {
      if (!tnames.includes(key) && key !== "tnames" && key !== "_") {
        if (!flag) {
          paramString += "&";
        }
        paramString += `${key}=${value}`;
        flag = false;
      }
    }
  } else {
    for (const [key, value] of Object.entries(queries)) {
      if (key !== "ct" && key !== "_" && key !== "title") {
        if (!flag) {
          paramString += "&";
        }
        paramString += `${key}=${value}`;
        flag = false;
      }
    }
  }

  let myqueryParams;
  if (isCompoundText) {
    myqueryParams = `?${paramString}&ct=${decodeURIComponent(ct)}`;
  } else {
    myqueryParams = `?${paramString}&title=${decodeURIComponent(title)}`;
  }
  config.ct = ct;
  return myqueryParams;
}
/**
 * get the design name from url path
 * @returns{string}
 */
export function getDesignName() {
  let pathName = window.location.pathname;
  var startName = pathName.slice(pathName.indexOf("/") + 1);
  return startName.substring(0, startName.indexOf("/"));
}
/**
 * gets whether the current page is a download page
 * @returns {boolean}
 */
export function isDownloadPage() {
  return window.location.href.toLowerCase().indexOf("download") != -1;
}
/**
 * check if user use facebook application or not
 * @returns {boolean} if true then user use facebook application
 */
export function isFacebookApp() {
  let ua = navigator.userAgent || navigator.vendor || window.opera;
  return /FBAV|FBAN/.test(ua);
}
/**
 * check if user use ios device
 * @returns {boolean} if return true mean user use iphone
 */
export function isIOS() {
  return /iPhone|iPad|iPod/.test(navigator.userAgent);
}
/**
 * check if user use android device
 * @returns {boolean} true if OS is android
 */
export function isAndroid() {
  return /Android/.test(navigator.userAgent);
}
/**
 * isDesktop check if user use desktop device
 * @returns {boolean}
 */
export function isDesktop() {
  var userAgent = navigator.userAgent;
  return /Windows NT|Macintosh|Ubuntu|Fedora|Debian/.test(userAgent) && !/Mobile|Android/.test(userAgent);
}
/**
 * create captcha with 4 random english numbers
 * @returns {string} english random numbers
 */
export function generateCaptcha() {
  const englishNumber = Math.floor(1000 + Math.random() * 9000).toString();
  return englishNumber; // still validate against English digits
}
/**
 * convert Arabic numbers to English numbers
 * @param {integer} number in arabic format
 * @returns {integer} return number in english format
 */
export function convertArabicToEnglish(input) {
  const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  const englishNumerals = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  return input.split('').map(char => {
    const index = arabicNumerals.indexOf(char);
    return index !== -1 ? englishNumerals[index] : char;
  }).join('');
}
/**
 * normalize input by removing spaces and converting arabic numbers to english numbers
 * @param {string} input
 * @returns {string} normalized input
 */
export function normalizeInput(input) {
  const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  const englishNumerals = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  return input
    .replace(/\s+/g, '') // Remove all spaces
    .split('')
    .map(char => {
      const index = arabicNumerals.indexOf(char);
      return index !== -1 ? englishNumerals[index] : char;
    })
    .join('');
}
/**
 * remove all elements by class name
 * @param {string} className 
 */
export function removeElementsByClassName(className) {
  // Get the collection of elements with the specified class name
  const elements = document.getElementsByClassName(className);
  // Convert the HTMLCollection to an array to avoid issues when removing elements
  const elementsArray = Array.from(elements);
  // Loop through the array and remove each element
  elementsArray.forEach(element => {
    element.parentNode.removeChild(element);
  });
}
/**
 * Sets the user as a VIP, adjusting settings and cookies accordingly.
 */
export function vipUser() {
  config.isVipUser = true;
  const designName = getDesignName();
  settingData.general.countofattemp = 200;
  config.maxTotalDownloadPerCountry = 200;
  config.maxDesktopDownload = 200;
  config.designsNotFollowRules.push(designName);
  //setCookie(`fb-${designName}`, "1", 12);
  setToLocalStorage(`fb-${designName}`, "1", config.fbSharedExpiredHours);
  // settingData.general.forceShare = undefined;
  // settingData.general.bodyModal = undefined;
  // settingData.general.showModal = undefined;
}
/**
 * create GUID id
 * @returns {string} guid id
 */
export function generateGUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
/**
 * create a session id and store it in cookie if not exists
 * @returns {string}
 */
export function getSessionId() {
  let guid = '';
  if (getCookie("sessionid") == null) {
    guid = generateGUID();
    setCookie("sessionid", generateGUID(), 4320); // 6 months :)
    return guid;
  }
  guid = getCookie("sessionid");
  return guid;
}
/**
 * create log user object
 * @param {object} data 
 * @param {string} url 
 * @returns {object}  
 */
export function createLogUser(data, url) {
  const pageType = config.pageType;
  const pageName = pageType;
  return {
    logDownloadUser: "y",
    userip: data.ip,
    countryCode: data.loc,
    deviceinfo: data.uag,
    ispwa: config.isPWA,
    domainurl: window.location.href,
    design: url,
    dotnetHost: pageName,
    uploadedImage: '',
    designedImage: '',
    namelist: '',
    ref: document.referrer,
    sessionid: config.sessionid
  };
}
/**
 * load bootstrap js if not loaded on the current page
 * @returns {Promise} resolves when bootstrap is loaded
 */
let bootstrapLoadingPromise = null;

export function loadBootstrapIfNeeded() {
  // console.log(window.bootstrap.Modal);
  if (typeof window !== "undefined" &&
    window.bootstrap &&
    window.bootstrap.Modal) {
    return Promise.resolve();
  }

  if (bootstrapLoadingPromise) {
    return bootstrapLoadingPromise;
  }

  bootstrapLoadingPromise = new Promise((resolve, reject) => {

    if (document.querySelector('script[data-bootstrap]')) {
      const checkInterval = setInterval(() => {
        if (window.bootstrap && window.bootstrap.Modal) {
          clearInterval(checkInterval);
          resolve();
        }
      }, 50);
      return;
    }

    const script = document.createElement("script");
    // script.src = "../js/bootstrap.bundle.min.js";
    script.src = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js"
    script.dataset.bootstrap = "true";

    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load Bootstrap.js"));

    document.head.appendChild(script);
  });

  return bootstrapLoadingPromise;
}

/**
 * try to open app by deep link or fallback to web link
 * @param {string} deepLink 
 * @param {string} fallbackLink 
 * @returns 
 */
export function tryOpenAppOrFallback(deepLink, fallbackLink) {
  // Flag to track if the app was likely opened
  let appOpened = false;
  // Listen for visibility change to detect if the app takes focus
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      appOpened = true; // App likely opened, page is no longer visible
    }
  });

  // Attempt to open the app with the deep link
  if (deepLink) {
    window.location = deepLink;
  } else {
    window.location.href = fallbackLink;
    return; // Exit if there's no deep link
  }

  // Fallback after a short delay, but only if the app didn't open
  window.setTimeout(() => {
    if (!appOpened && document.visibilityState === 'visible') {
      window.location.href = fallbackLink;
    }
  }, 4000);
}
/**
 * create whatsapp link
 * @param {string} message 
 * @param {string} link 
 * @returns 
 */
export function createWhatsAppLink(message, link) {
  const encodedMessage = encodeURIComponent(message);
  const fullMessage = `${encodedMessage}\n${link}`;
  const rawMessage = `${message}\n${link}`;
  const fallbackWebLink = `https://web.whatsapp.com/send?text=${fullMessage}`
  const deepWebLink = `whatsapp://send?text=${fullMessage}`;
  if (isAndroid() || isIOS()) {
    return {
      deepLink: deepWebLink,
      fallbackLink: fallbackWebLink,
      message: rawMessage
    };
  }
  // not android or Ios
  return {
    deepLink: null,
    fallbackLink: fallbackWebLink,
    message: rawMessage
  };
}
/**
 * create facebook messenger link
 * @param {string} message 
 * @param {string} link 
 * @returns 
 */
export function createFacebookMessengerLink(message, link) {
  const encodedLink = encodeURIComponent(link);
  const rawMessage = `${message}\n${link}`;
  const url = location.href
  const fallbackWebLink = `https://www.facebook.com/dialog/send?link=${encodedLink}&app_id=${config.appId}&redirect_uri=${url}`;
  const deepWebLink = `fb-messenger://share/?link=${encodedLink}`;
  if (isAndroid() || isIOS()) {
    return {
      deepLink: deepWebLink,
      fallbackLink: fallbackWebLink,
      message: rawMessage
    };
  }
  return {
    deepLink: null,
    fallbackLink: fallbackWebLink,
    message: rawMessage
  };
}

/**
 * copy text to clipboard
 * @param {string} text is the text to copy
 * @param {string} platform is either whatsapp or facebook
 * @param {string} copyStatus is a DOM element to show copy status
 */
export function copyToClipboard(text, platform, copyStatus) {
  copyStatus.classList.remove("d-none");
  navigator.clipboard.writeText(text).then(() => {
    if (platform == "whatsapp")
      copyStatus.innerHTML = '✅  تم نسخ الرابط يمكنك لصقه يدويًا'
    else if (platform == "facebook")
      copyStatus.innerHTML = '✅  تم نسخ الرابط يمكنك لصقه يدويًا'
  });
  window.setTimeout(() => {
    copyStatus.classList.add("d-none");
  }, 4000);
}
/**
 * create dynamic url for facebook
 * @param {string} appid 
 * @param {object} settingData 
 * @param {string} pageid 
 * @param {string} designName 
 * @param {string} pageurl 
 * @param {string} imgid 
 * @returns 
 */
export function createFbUrl(appid, settingData, pageid, designName, pageurl, imgid) {
  const currentDomain = window.location.origin;
  const postid = settingData.general.fbpostid;
  //const isShareLink = settingData.general?.isSharelink;
  const isFacebookApp = /FBAN|FBAV/i.test(navigator.userAgent);
  const encode = (s) => encodeURIComponent(s);
  const safeEncode = (s) => {
    try {
      return encodeURIComponent(decodeURIComponent(s));
    } catch (e) {
      return encodeURIComponent(s);
    }
  };

  const shareUrl = config.currentSharedLink;


  const fbDomain = "https://www.facebook.com/";
  let finalUrl = "";

  if (config.isSharedLink) {

    const target = shareUrl;

    if (isDesktop()) {
      finalUrl =
        `https://facebook.com/sharer/sharer.php` +
        `?u=${encode(target)}` +
        `&app_id=${encode(appid)}` +
        `&redirect_uri=${safeEncode(pageurl)}`;
    } else if (isFacebookApp) {
      finalUrl =
        `https://mtouch.facebook.com/dialog/feed` +
        `?app_id=${encode(appid)}` +
        `&display=popup` +
        `&link=${encode(target)}` +
        `&redirect_uri=${safeEncode(pageurl)}`;
    } else {
      finalUrl =
        `https://facebook.com/sharer/sharer.php` +
        `?u=${encode(pageurl)}` + // you probably want to share the pageurl on mobile fallback
        `&app_id=${encode(appid)}` +
        `&redirect_uri=${safeEncode(pageurl)}`;
    }

    return finalUrl;
  }

  if (!pageid || !postid) {
    console.error("Missing pageid or postid for non-share link");
    return "";
  }

  const postUrl = `${fbDomain}${pageid}/posts/${postid}`;
  const encodedPost = encode(postUrl);
  const encodedAppId = encode(appid);
  const encodedRedirect = safeEncode(pageurl);

  if (isDesktop()) {
    finalUrl =
      `https://facebook.com/sharer/sharer.php` +
      `?u=${encodedPost}` +
      `&app_id=${encodedAppId}` +
      `&redirect_uri=${encodedRedirect}`;
  } else if (isFacebookApp) {
    finalUrl =
      `https://mtouch.facebook.com/dialog/feed` +
      `?app_id=${encodedAppId}` +
      `&display=popup` +
      `&link=${encodedPost}` +
      `&redirect_uri=${encodedRedirect}`;
  } else {
    finalUrl =
      `https://facebook.com/sharer/sharer.php` +
      `?u=${encodedPost}` +
      `&app_id=${encodedAppId}` +
      `&redirect_uri=${encodedRedirect}`;
  }

  if (imgid !== undefined && imgid !== null && imgid !== "") {
    finalUrl += `&id=${encode(imgid)}`;
  }

  return finalUrl;
}

// fix problem if decode twice
function safeEncodeParam(url) {
  try {
    // decodeURIComponent will throw on invalid sequences, so wrap in try/catch
    const decoded = decodeURIComponent(url);
    return encodeURIComponent(decoded);
  } catch (e) {
    // If decodeURIComponent fails, assume url wasn't encoded and just encode it
    return encodeURIComponent(url);
  }
}

/**
 * save design details into localStorage
 * @param {object} newObject 
 * @param {string} key 
 */
export function saveDesignObject(newObject, key) {
  const storedData = JSON.parse(window.localStorage.getItem(key)) || [];
  // check if the items not greater than storedData
  if (storedData.length >= config.maxHistoryItems) {
    storedData.shift(); // remove the old one
  }
  storedData.push(newObject);
  // save items
  window.localStorage.setItem(key, JSON.stringify(storedData));
}
/**
 * 
 *get designedObject from localStorage
 */
export function getStoredDesigns(key) {
  const storedData = window.localStorage.getItem(key);
  return storedData ? JSON.parse(storedData) : []; // Convert back to an object
}
/**
 * get value from query
 * @param {string} qname 
 * @returns 
 */
export function getSingleQuery(qname) {
  const params = new window.URLSearchParams(window.location.search);
  return params.get(qname) || "";
}
/**
 * check if the user come from same resources
 * @returns 
 */
export function isSameResources() {
  let tokenKey = getSingleQuery('token');
  //let cookieQuery = getCookie(config.designName + "-info");
  // we stopped cookies in this function
  let cookieQuery = getLocalStorageValue(config.designName + "-info");
  // console.log("myquerycookie : " + cookieQuery);
  let cookieValuesRaw = '';
  let cookieImageName = "";
  let cookieVideoName = "";
  let isSameResource = false;
  if (cookieQuery != undefined || cookieQuery != null) {
    cookieValuesRaw = cookieQuery.split("&");
  }
  for (var index = 0; index < cookieValuesRaw.length; index++) {
    if (cookieValuesRaw[index].split("=")[0] == 'token') {
      if (tokenKey == cookieValuesRaw[index].split("=")[1])
        isSameResource = true;
    }
    if (cookieValuesRaw[index].split("=")[0] == 'imgname') {
      cookieImageName = cookieValuesRaw[index].split("=")[1];
    }
    if (cookieValuesRaw[index].split("=")[0] == 'videoname') {
      cookieVideoName = cookieValuesRaw[index].split("=")[1];
    }
  }

  let _resource = { imageName: cookieImageName, videoName: cookieVideoName, isSameResource: isSameResource }
  return _resource;
}

// check if localstorge has images and if true clear all images
export function clearLocalStorageImages() {
  const keys = Object.keys(window.localStorage).filter(key => key.startsWith('img'));
  keys.forEach(key => window.localStorage.removeItem(key));
}
/**
 * check if the country from golf or not
 * @returns{boolean}
 */
export function isFromGolfCountries() {
  let country = getCookie("country");
  let golfCountris = [
    'KW',
    'SA',
    'OM',
    'QA',
    'AE',
    'BH',
    'JO',
    'UK'
  ];
  let isCountryExists = golfCountris.find(c => c == country) == country;
  return isCountryExists;
}
/**
 * 
 */
export function runNotApplicableRules() {
  // if (domain.indexOf('localhost') != -1) {
  //   config.isUserNotApplicable = true;
  //   return;
  // }

  let country = getCookie("country");
  let design = getDesignName();
  let isCountryExists = config.countriesNotFollowRules.find(c => c == country) == country;
  let isDesignExists = config.designsNotFollowRules.find(d => d == design) == design;
  // this part make the app not applicable if he use facebook app
  if (isFacebookApp()) {
    // disable this option
    config.isUserNotApplicable = false;
  }
  // countries and designs not applicable for share even he use facebook app
  if (isCountryExists && isDesignExists) {

    config.isUserNotApplicable = true;
  }

  // No share for these countries
  // if(  country=="KW" 
  //   || country =="QA" 
  //   || country =="AE" 
  //   || country =="BH" ){
  //     settingData.general.forceShare = false;
  //     isUserNotApplicable = true;
  // }
  // if(country=="KW" 
  //   || country =="SA" 
  //   || country =="QA" 
  //   || country =="OM"
  //   || country =="JO" 
  //   || country =="AE" 
  //   || country =="BH" 
  //   || country =="BH" 
  //   || country =="UK"){
  //     maxTotalDownloadPerCountry = 120 ;
  // }
  // exception country
  // if(country=="KW"){
  //   // you can add array of designs here not only single one
  //   let specificDesigns = ["rm-ph"];
  //   let isSpecificDesignExists = specificDesigns.find(d=>d== design) == design;
  //   if(isSpecificDesignExists){
  //     settingData.general.forceShare = false;
  //     isUserNotApplicable = true;
  //   }
  // }
}
/**
 * 
 * @param {string} text 
 * @returns 
 */
export function isEnglishLetters(text) {
  if (text.match(/[a-z]/i)) {
    return true;
  } else {
    return false;
  }
}
export function hideElement(names, show) {
  names.forEach(name => {
    document.querySelectorAll(`[name='${name}']`).forEach(element => {
      element.style.display = show ? "block" : "none";
    });
  });
}
/**
 * 
 * @param {boolean} status 
 * @returns 
 */
export function removeTnames(status) {
  if (status) {
    document.querySelectorAll("[name='tnames']").forEach(el => el.remove());
    return;
  }

  if (!document.querySelector("[name='tnames']")) {
    const input = document.createElement("input");
    Object.assign(input, {
      type: "hidden",
      name: "tnames"
    });
    input.setAttribute("settingData-type", "string");

    document.querySelector("form").appendChild(input);
  }
}
/**
 * change Images according to new occasion
 * @param {string} imageName 
 */
// export function addImageToContainer(imageName) {
//   let container = document.querySelector('.decoration-container');
//   // console.log("get the container");
//   if (!container) {
//     container = document.createElement('div');
//     container.classList.add('decoration-container');
//     document.body.appendChild(container, document.body.firstChild);

//   }
//   const img = document.createElement('img');
//   img.src = `../preview/${imageName}`;
//   img.classList.add('ramadan-decoration', 'decoration-1');
//   img.setAttribute("alt", "شهادات تقدير للاطفال");
//   img.setAttribute("loading", "lazy");
//   img.width = 100;
//   img.height = 100;
//   img.setAttribute("fetchpriority", "low");
//   container.appendChild(img);
// }
export function addImageToContainer(imageName) {
  const container = document.querySelector('.decoration-container');
  if (!container) return;

  const img = document.createElement('img');
  img.src = `../preview/${imageName}`;
  img.className = 'ramadan-decoration decoration-1';
  img.alt = 'شهادات تقدير للاطفال';
  img.width = 100;
  img.height = 100;
  img.fetchPriority = 'low';

  container.appendChild(img);
}



/**
 * Checks if the current page is the result page.
 * @returns {boolean}
 */
export function isResultPage() {
  // var field = 'designname';
  var url = window.location.href;
  if (url.indexOf("download")) return true;
  else if (url.indexOf("?" + "imagesystem" + "=") != -1) return true;
  else if (url.indexOf("&" + "designname" + "=") != -1) return true;
  else if (url.indexOf("&" + "title" + "=") != -1) return true;
  return false;
}

/**
 * Removes emojis from a string.
 * @param {string} string 
 * @returns {string}
 */
export function removeEmojis(string) {
  var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
  return string.replace(regex, '');
}

/**
 * help to save state of the input
 * @returns {void}
 */
export function setUserStates() {
  let textboxes = settingData.textBoxes;
  if (textboxes.length == 1) {
    return;
  }
  for (let i = 0; i < textboxes.length; i++) {
    let input = textboxes[i].id;
    let storageKey = `${config.designName}_${input}`;
    let currentInput = document.getElementById(`${input}`);
    let value = sessionStorage.getItem(storageKey);
    if (value != null && value != "") {
      currentInput.value = value;
    }
  }
}
// send user state and save it in session storage
export function submitUserState() {
  let textboxes = settingData.textBoxes;
  if (textboxes == 1)
    return;
  for (let index = 0; index < textboxes.length; index++) {
    const input = textboxes[index].id;
    let checkbox = document.getElementById(`chk_${input}`);
    let storageKey = `${config.designName}_${input}`;
    let currentInput = document.getElementById(`${input}`);
    if (checkbox) {
      if (checkbox.checked) {
        sessionStorage.setItem(storageKey, currentInput.value);
      }
    }
  }
}
/**
 * check if the userAgent belong to crawlers or not
 * @param {string} isp 
 * @param {string} userAgent 
 * @returns 
 */
export function isCrawler(isp, userAgent) {
  const crawlers = ["google", "facebook", "MICROSOFT-CORP-MSN-AS-BLOCK"];
  let isCrawlerAgent = crawlers.includes(isp.toLowerCase()) || (userAgent.toLowerCase().includes('bot') && !userAgent.toLowerCase().includes('google'));
  config.isCrawlers = isCrawlerAgent;
  return isCrawlerAgent;
}

/**
 * Returns the crawler type.
 */
export function getCrawlerType(isp, userAgent) {
  if (isp.toLowerCase() === "google" && userAgent.includes('Mediapartners-Google')) {
    return "Mediapartners-Google";
  }
  return isp.charAt(0).toUpperCase() + isp.slice(1);
}
export function rqown() {
  var _ownreq = getCookie("_ownreq");
  if (_ownreq == config.appId)
    return true;
  if (getQueryValue("own") != undefined) {
    let gvalue = getQueryValue("own");
    if (gvalue == config.appId) {
      setCookie("_ownreq", config.appId, 21900, false);
      return true;
    }
  }
  return false;
}
/**
 * check if the user disable cookies or not
 */
export function isDisableCookies() {
  if (!navigator.cookieEnabled) {
    return true;
  }
}
export async function isUserProxyRequest() {
  const ip = getCookie('ip');
  let isUseProxy = false;
  const dbResponse = await apihandler.fetchUserBlockStatus(ip);
  if (dbResponse && dbResponse.block > 0)
    isUseProxy = true;
  return isUseProxy;
}
/**
 * collect data from hidden fileds
 * @returns 
 */
export function collectData() {
  let data = {};
  if (settingData.hiddenFields != null) {
    for (let index = 0; index < settingData.hiddenFields.length; index++) {
      let fieldName = settingData.hiddenFields[index].name;
      let inputElements = document.getElementsByName(fieldName);
      if (inputElements.length > 0) {
        data[fieldName] = inputElements[0].value;
      }
    }
  }
  if (settingData.textBoxes != null) {
    for (let index = 0; index < settingData.textBoxes.length; index++) {
      let fieldName = settingData.textBoxes[index].name;
      let inputElements = document.getElementsByName(fieldName);
      if (inputElements.length > 0) {
        data[fieldName] = inputElements[0].value;
      }
    }
  }
  //remove name from hiddenFiled
  document.querySelectorAll('input[type="hidden"]').forEach(input => {
    //if(input.name!=TokenKey)
    input.removeAttribute('name');
  });

  // Remove name attribute from text inputs
  document.querySelectorAll('input[type="text"]').forEach(input => {
    input.removeAttribute('name');
  });
  return data;
}

export function isUserExceededTries() {
  // validate user means users can download more if max download country not limit
  const isvalid = validateUsr();


  if (!isvalid && !config.isCookeValuesEqual) {
    var d1 = new Date();
    d1.setTime(d1.getTime());
    var flag = getCookie("_flag");
    var d2 = new Date(flag);
    var dif = diff_hours(d1, d2);
    let isHourUnit = true;
    if (dif < 1) {
      dif = Math.floor((d2 - d1) / (1000 * 60));
      isHourUnit = false;
    }
    ui.hideLoaderContainer();
    document.querySelector(".image-designed").innerHTML = "";
    var message =
      "عفوا لقد نفذت عدد المرات الخاصة بكم يرجى إعادة المحاولة بعد عدد ";
    message += " " + dif + `${isHourUnit ? 'ساعة' : 'دقيقة'}`;
    // clear message div if exists
    document.querySelector(".message").innerHTML = "";

    ui.createErrorDiv(message, ".image-designed");
    ui.showDomByClassName('image-designed', 'flex');


    // collect extra info
    const ip = getCookie("ip") ?? "";
    //const designCount = getCookie(config.designName)
    const designCount = getLocalStorageValue(config.designName);
    const country = getCookie("country") ?? "";
    const device = navigator.userAgent;
    let url = location.href;
    let logUser = createLogUser({ ip, loc: country, uag: device }, url);
    let _totalDownload = getCookie(config.totaldowloadKey);
    let _totalDesigns = designCount != null ? parseInt(designCount) : 0;
    let isExccedTotalDownload = 1;

    logUser.ispwa = config.isPWA;
    logUser.isExceedDesign = 1;
    logUser.isExceedTotalDownload = isExccedTotalDownload;
    logUser.flag = flag != null ? flag : "";
    logUser.totalDownload = _totalDownload != null ? _totalDownload : 0;
    logUser.totalDesigns = _totalDesigns;
    apihandler.logUsersOfDesign(logUser);

    return;
  }
}

export function validateTotalDownloadPerCountry(countryMaxCount) {
  // get total
  let totalDownload = getCookie(config.totaldowloadKey);
  if (totalDownload == '' || totalDownload == undefined) {
    return;
  }
  let balance = parseInt(totalDownload);
  // console.log(balance);
  if (balance >= countryMaxCount) {
    if (messageDiv) {
      messageDiv.innerHTML = "";
    }

    ui.hideLoaderContainer();
    if (imageDesigned) {
      imageDesigned.innerHTML = "";
      imageDesigned.style.display = 'flex';
    }
    ui.createDynamicErrorMessage();
    let flag = getCookie("_flag");
    //let designCount = getCookie(config.designName);
    let designCount = getLocalStorageValue(config.designName);
    // collect extra info
    let ip = getCookie("ip") ?? "";
    let country = getCookie("country") ?? "";
    let device = navigator.userAgent;
    let url = location.href;
    let logUser = createLogUser({ ip, loc: country, uag: device }, url);
    let _totalDownload = getCookie(config.totaldowloadKey);
    let _totalDesigns = designCount != null ? parseInt(designCount) : 0;
    let isExccedTotalDownload = 0;
    if (_totalDownload != null) {
      if (parseInt(_totalDownload) >= parseInt(config.maxTotalDownloadPerCountry)) {
        isExccedTotalDownload = 1;
      }
    }
    logUser.ispwa = config.isPWA;
    logUser.isExceedDesign = 1;
    logUser.isExceedTotalDownload = isExccedTotalDownload;
    logUser.flag = flag != null ? flag : "";
    logUser.totalDownload = _totalDownload != null ? _totalDownload : 0;
    logUser.totalDesigns = _totalDesigns;
    apihandler.logUsersOfDesign(logUser);
    if (imageContainer) {
      imageContainer.innerHTML = "";
    }
    return true;
  }
  return false;
}
export async function applyForceValidateShare(settingData) {

  // if (config.domain.indexOf('localhost') != -1) {
  //   return;
  // }
  // check if user share before

  if (isUserShareBefore()) {
    ui.hideDomByClassName("download-T-Phone");
    //fillAdsenceContainers("download");
    //loadGoogleadsPerPage();
    return;
  }
  let currentSharesCount;
  let isApiFbError = false;
  currentSharesCount = await apihandler.getCurrentShareCount();

  let prevShareCount = 0;
  // check error comes from Fb 
  if (isApiFbError)
    return;
  // user has a value of share in cookie

  if (isShareCountExists()) {
    prevShareCount = getShareCountCookie();

    // case prevShareCount is not number
    if (isNaN(prevShareCount)) {
      setShareCountCookie(currentSharesCount);
      loadBootstrapIfNeeded()
        .then(() => {
          ui.showForceModel();
        });
      return;
    }
    if (parseInt(currentSharesCount) > parseInt(prevShareCount)) {

      // user share change the status of Modal to hide and save fb-designName
      //setCookie("fb-" + config.designName, "1", 4);
      setToLocalStorage("fb-" + config.designName, "1", config.fbSharedExpiredHours);
      removeLocalStorageValue(`${config.lastChance}-${config.designName}`);
      ui.showDomByClassName("download-T-Phone");
      // check if the modal not exists and if exists hide it
      //fillAdsenceContainers("download");
      // loadGoogleadsPerPage();
    } else {

      // user came from fb and not share
      // 1- show popup and ask for share , show also a new button to refresh the page
      // changeModalStatus function add new button to refresh the page
      //delete the non-share for the current design to give a new chance to the user
      //setCookie(`non-share-${config.designName}`, 1, -4);
      removeLocalStorageValue(`${config.noShareStatus}-${config.designName}`);

      // setToLocalStorage()
      loadBootstrapIfNeeded()
        .then(() => {
          ui.showForceModel();
        });
      // ui.showForceModel();
      ui.changeModalStatus();
    }
  }
  else {
    // problem currentSharesCount always come undefined although we access the api and set the value to it, please fix this problem


    // first load user and hasn't shares count value 
    setShareCountCookie(currentSharesCount);

    //delete the non-share for the current design to give a new chance to the user
    removeLocalStorageValue(`${config.noShareStatus}-${config.designName}`);
    // ui.showForceModel();
    loadBootstrapIfNeeded()
      .then(() => {
        ui.showForceModel();
      });
  }
}
function isUserShareBefore() {
  let cookieName = `fb-${config.designName}`;
  //let isExists = getCookie(cookieName);
  let isExists = getLocalStorageValue(cookieName);
  if (isExists != undefined || isExists == '')
    return true;
  else
    return false;
}
function isShareCountExists() {
  let cookieName = `${config.Shares}-${config.designName}`;
  //let isExists = getCookie(cookieName);
  // change to localStorage
  let isExists = getLocalStorageValue(cookieName);
  if (isExists != undefined || isExists == '')
    return true;
  else
    return false;
}
function setShareCountCookie(count) {
  let cookieName = `${config.Shares}-${config.designName}`;
  // 5 minutes only
  // change to localStorage
  const minutes = config.WaitTimeAfterUserShareInMinutes / 60;
  setToLocalStorage(cookieName, count, minutes);
  //setCookie(cookieName, count, 5);
}
function getShareCountCookie() {
  let cookieName = `${config.Shares}-${config.designName}`;
  //let sharesCount = getCookie(cookieName);
  // change to localStorage
  let sharesCount = getLocalStorageValue(cookieName);
  if (sharesCount != '' || sharesCount != undefined)
    return parseInt(sharesCount);
  else
    return '';
}
export function fillTotalDownload() {
  let totalDownload = getCookie(config.totaldowloadKey);

  if (totalDownload == undefined) {
    // setCookie(totaldowloadKey,"1",cookieHours);
    setCookieWithFlagExpiry(config.totaldowloadKey, 1);
  } else {
    let count = parseInt(totalDownload);
    //console.log('calling totalDownload : ' + count)
    setCookieWithFlagExpiry(config.totaldowloadKey, count + 1);

  }
}
function fixquery(query) {
  // fix new querystring and set them to default values
  var slaps = query.split("&");
  var ismulti = "";
  var ispdf = "";
  for (let index = 0; index < slaps.length; index++) {
    var part = slaps[index];
    var equalindex = part.indexOf("=");
    var currentqs = part.substring(0, equalindex);
    var currentqv = part.substring(equalindex + 1);
    if (currentqs.toLowerCase() == "ismulti") ismulti = currentqv;
    if (currentqs.toLowerCase() == "ispdf") ispdf = currentqv;
    if (currentqs.toLowerCase() == "error_message") {
      var qvalue = "&error_message=" + currentqv;
      query = query.replace(qvalue, "");
    }
  }
  if (ismulti == "") query = query + "&ismulti=false";
  if (ispdf == "") query = query + "&ispdf=false";

  return query;
}
export function saveCurrentDesign(data, type = 'image') {
  let isAcceptCookies = navigator.cookieEnabled;
  if (isAcceptCookies) {
    if (data != null) {
      let url = location.href;
      url = url.replace('#_=_', '');
      // url = url.replace('fbback=y','');
      url = url.replace('#gsc.tab=0', '');
      url = url.replace('#google_vignette', '');
      url = url.replace('#', '');
      let cookieInfoValues = url.substring(url.indexOf("?") + 1);
      //filter url and prevent facebook queries
      let rawquery = cookieInfoValues.split('&');

      let queriesFilter = "";
      for (var index = 0; index < rawquery.length; index++) {
        if (
          rawquery[index].indexOf("fbback=y") == -1 &&
          rawquery[index].indexOf("error_code") == -1 &&
          rawquery[index].indexOf("error_message") == -1
        ) {
          if (index > 0)
            queriesFilter += "&";

          queriesFilter += rawquery[index];
          //    if(index<rawquery.length - 1)
          //     queriesFilter +="&" ;
        }
      }
      if (type == 'image') {
        let imgSource = data.imagesDesigned[0];
        var imgName = imgSource.substring(imgSource.lastIndexOf("/") + 1);
        let domainOfImage = config.isUsePhpForDownload ? `${config.domain}/images/shared` : data.domainUrl;
        queriesFilter += "&imgname=" + domainOfImage + "/" + imgName;
      } else {
        let videoName = data.videoDesigned;
        queriesFilter += "&videoname=" + data.domainUrl + "/" + videoName;
      }
      // setCookie(config.designName + "-info", decodeURIComponent(queriesFilter), 1);
      setToLocalStorage(config.designName + "-info", decodeURIComponent(queriesFilter), 1)
    }
  }
}
/**
 * get the current index or url service
 * @param {number} index 
 * @returns {object} current service url
 */
export function getCurrentUrl(index, type = 'image') {
  let links = [];
  if (type == 'image') {
    config.services.images.forEach((service) => {
      links.push(service);
      return links[index];
    });
  }
  config.services.videos.forEach((service) => {
    links.push(service);
  });
  return links[index];
}
export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
}
/**
 * get the load balancer url
 * @returns {Promise<string>}
 */
export function getLoadBalancer(type = 'image') {
  return new Promise(function (resolve, reject) {
    const balancer = type == 'image' ? config.loadBalancer.images[0] : config.loadBalancer.videos[0];
    if (!balancer?._balancerHost) {
      console.log("balncer not work");
      return resolve(getRandomInt(0, 10));
    }
    const url = balancer._balancerHost;
    const auth = balancer._balancerAuth;
    fetch(url, {
      method: "GET",
      headers: {
        "Authorization": auth,     // ← Correct header syntax
        "Accept": "text/plain"
      }
    })
      .then(response => {
        if (response.ok) {
          return response.text();     // ← Return the promise chain
        } else {
          throw new Error("Not ok");
        }
      })
      .then(text => {
        const num = parseInt(text.trim(), 10);
        if (!isNaN(num) && num >= 0) {
          resolve(num);               // ← Real number!
        } else {
          resolve(getRandomInt(0, 10));
        }
      })
      .catch(err => {
        console.warn("Load balancer failed, using random:", err.message);
        resolve(getRandomInt(0, 10));  // ← Always resolve with a number
      });
  });
}
export async function connect(settingData, dataCloud = null) {


  let query = window.location.href.slice(window.location.href.indexOf("?") + 1);
  let url = "";
  let designType = settingData.general.design;
  //if(_resource==null)
  let _resource = isSameResources();

  config.isCookeValuesEqual = _resource.isSameResource;
  let cookieImageName = _resource.imageName;
  let cookieVideoName = _resource.videoName;
  let serviceImageUrl = _resource.imageName.substring(0, _resource.imageName.lastIndexOf("/"));
  let serviceVideoUrl = _resource.videoName.substring(0, _resource.videoName.lastIndexOf("/"));
  let imageInServiceUrl = _resource.imageName.substring(_resource.imageName.lastIndexOf("/") + 1);
  let videoInServiceUrl = _resource.videoName.substring(_resource.videoName.lastIndexOf("/") + 1);

  // canvas designs keep their made image locally: a matching record
  // restores the local render instead of any server file
  if (config.isCookeValuesEqual && designType == "image") {
    let canvasState = await canvasRender.getCachedState(config.designName, imageInServiceUrl);
    if (canvasState == "stored") {
      let cacheData = { "domainUrl": `${serviceImageUrl}`, "pdf": null, "error": null, "videosDesigns": null, "imagesDesigned": [`${imageInServiceUrl}`], "staticResources": null, "fbImage": null, "localUrl": canvasRender.getStoredImage(imageInServiceUrl) };
      events.fireImagedesignedSuccess(settingData, cacheData, serviceImageUrl, true, dataCloud);
      return;
    }
    if (canvasState == "missing") {
      config.isCookeValuesEqual = false; // render it locally below
    }
  }

  query = fixquery(query);
  // check if it's cahced

  if (config.isCookeValuesEqual) // must be the page valid
  {
    let cacheData = {};
    let imageDomain = config.isUsePhpForDownload ? `${config.domain}/images/shared/` : serviceImageUrl;
    cookieImageName = config.isUsePhpForDownload ? cookieImageName : imageInServiceUrl;
    if (designType == "image") {
      // check if it's a single image only 
      var isMultimages = getQueryValue("ismulti");
      if (isMultimages == '' || isMultimages == "true") {
        cacheData = { "domainUrl": `${imageDomain}`, "pdf": null, "error": null, "videosDesigns": null, "imagesDesigned": [`${cookieImageName}`], "staticResources": null, "fbImage": null };
        events.fireImagedesignedSuccess(settingData, cacheData, imageDomain, true, dataCloud);
      } else {
        // we don't use php in this version
        //  callAjaxToDesign(settingData, url,dataCloud);
        // isUsePhpForDownload ==true ? callAjaxToDesign(settingData, url,dataCloud) : sendHttpService(settingData, url,dataCloud);
      }
    }
    else if (designType == "video") {
      // load video if has a link
      let videoDomain = config.isUsePhpForDownload ? `${config.domain}/images/shared/videos/${cookieVideoName}` : `${serviceVideoUrl}/${videoInServiceUrl}`

      cookieVideoName = config.isUsePhpForDownload ? cookieVideoName.substring(cookieVideoName.lastIndexOf('/') + 1) : videoInServiceUrl;

      //domain = isUsePhpForDownload ? `${domain}/images/shared/videos/${cookieVideoName}`
      var videoCache = { "domainUrl": `${videoDomain}`, "videoDesigned": `${cookieVideoName}` };

      // implement video part
      events.fireVideoDesignedSuccess(settingData, videoCache, null, true);
    }
    return;
  }
  // if not cached data continue
  let myqueryParams = getRequestParams();


  let urlDetails = "";
  // this part only for using php 
  // data manipulation by js
  // check if something Error never send to the server and tell user he must return to index
  // tell spiders about the website in some text info

  if (designType == "image") {
    // canvas designs render on the client: no balancer, no server round trip.
    // a design whose registry RenderMode is "Server" skips this entirely
    try {
      let designConfig = await canvasRender.getDesignConfig(config.designName);
      if (canvasRender.isCanvasEntry(designConfig)) {
        let payload = apihandler.preparePayload(settingData);
        let localData = await canvasRender.renderDesign(payload, designConfig);
        if (localData) {
          saveCurrentDesign(localData);
          config.domain = window.location.origin;
          events.fireImagedesignedSuccess(settingData, localData, window.location.origin, false, dataCloud);
          return;
        }
      }
    } catch (e) {
      if (e && e.isValidationError) {
        // a text or photo this design expects did not arrive: show the
        // platform error with its retry button and stop - never fall
        // back to a server render of an incomplete design
        console.warn("canvas validation failed", e);
        let imageDesigned = document.querySelector(".image-designed");
        if (imageDesigned) {
          imageDesigned.innerHTML = ui.createErrorInfo();
          imageDesigned.setAttribute("display", "flex");
        }
        return;
      }
      // local render failed: continue with the server flow below
      console.warn("canvas render failed, using the server flow", e);
    }
    // here I can stop people who did not come from index
    apihandler.getUrlDetails(myqueryParams).then(data => {
      urlDetails = data;
      url = urlDetails;
      config.domain = url[2];
      // console.log(data);
      apihandler.sendHttpService(settingData, url, dataCloud);
      return;
    });
  }
  if (designType == "video") {
    apihandler.getUrlDetails(myqueryParams, "video").then(data => {
      urlDetails = data;
      url = urlDetails;
      config.domain = url[2];
      apihandler.sendHttpService(settingData, url, dataCloud);
      return;
    });
  }
}
/**Fix in fb query */
export function fixDuplicateShare(url) {
  window.location.href = url;
}
// function to forceValidate
export function isForceVlidateShare(settingData) {
  if (settingData.general.isForceValidateShare != undefined) {
    if (settingData.general.isForceValidateShare == true) {
      return true;
    }
  }
  return false;
}
export function adjustdateInputEvents() {

  const radioButtons = document.querySelectorAll('input[type="radio"]');

  if (typeof settingData === 'undefined') {
    return;
  }

  if (settingData.general.design !== "video") {
    radioButtons.forEach(radio => {
      radio.addEventListener('click', function () {
        if (this.name === 'datetime') {
          const dateContainers = document.querySelectorAll('.date-container');
          const tgroup = document.getElementById('tgroup');
          const tnames = document.querySelector('[name="tnames"]');

          if (this.value === 'no') {
            // Hide all date containers
            dateContainers.forEach(el => el.style.display = 'none');

            // Safely clear/set values
            if (tgroup) tgroup.value = '';
            if (tnames) tnames.value = 't1,t2';
          } else {
            // Show all date containers (restore default display)
            dateContainers.forEach(el => el.style.display = '');

            if (tgroup) tgroup.value = 't3,t4,t5';
            if (tnames) tnames.value = 't1,t2,t3';
          }
        }
      });
    });
  }
}
//remove google seach has from query
export function removeGooglegscFromQuery() {
  if (window.location.hash.includes("gsc.tab=0")) {
    history.replaceState(null, null, window.location.pathname + window.location.search);
  }
}
/**
 * 
 * @param {string} base64String 
 * @returns {object}
 */
export function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
}
/**
 * save data with key and value into localStorage
 * @param {string} key 
 * @param {string} newValue 
 * @param {Date} dt
 * @param {number} expireHours 
 */
export function setToLocalStorage(key, newValue, expireHours, customExpire = null) {
  const now = Date.now();
  let expiry = now + expireHours * 60 * 60 * 1000;
  if (customExpire) {
    expiry = customExpire;
  }
  let currentData = { value: null, expiry: 0 };

  const raw = localStorage.getItem(key);
  if (raw) {
    try {
      currentData = JSON.parse(raw);
    } catch (e) {
      // corrupted → treat as missing
    }
  }

  // If expired or missing → start fresh
  if (!raw || Date.now() > currentData.expiry) {
    currentData = { value: newValue, expiry };
  } else {
    // Still valid → update the value (keep same expiry or refresh it?)
    // We refresh expiry on every update (common pattern for "sliding expiration")
    currentData.value = newValue;
    currentData.expiry = expiry; // ← sliding window: resets timer on activity
  }
  localStorage.setItem(key, JSON.stringify(currentData));
  return currentData.value; // returns the newly saved value
}
/**
 * 
 * @param {string} key 
 * @returns {void} 
 */
export function removeLocalStorageValue(key) {
  const raw = localStorage.getItem(key);
  if (!raw) return null;
  localStorage.removeItem(key);
}


/**
 * 
 * @param {string} key 
 * @returns {object}
 */
export function getLocalStorageValue(key) {
  const raw = localStorage.getItem(key);
  if (!raw) return null;

  try {
    const data = JSON.parse(raw);
    if (Date.now() > data.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return data.value;
  } catch (e) {
    localStorage.removeItem(key);
    return null;
  }
}
/**
 * 
 * @param {object} mdContainer 
 */
export async function fireSubscribeModalAnswerEvent(mdContainer) {
  //console.log(Notification.permission);
  //if (Notification.permission === 'granted') {
  try {
    const sub = await sw.subscribeUserToPush().then(
      () => {
        mdContainer.remove();
        document.querySelector(".modal-backdrop")?.remove();
        document.body.classList.remove("modal-open");
      }
    );

    //console.log('Subscribed:', sub);

    // Show toast message
  } catch (err) {
    console.error('Subscription failed after permission already granted:', err);
    // أعرض رسالة خطأ للمستخدم إن الاشتراك فشل
  } finally {
    mdContainer.remove();
    document.querySelector(".modal-backdrop")?.remove();
    document.body.classList.remove("modal-open");
  }
  //}
}
/**
 * 
 * @param {object} mdContainer 
 * @returns 
 */
export async function fireSubscribeModalRefuseEvent(mdContainer) {

  if (mdContainer) {
    setToLocalStorage(config.subscribeKey, "1", 3);
    mdContainer.remove();
    document.querySelector(".modal-backdrop")?.remove();
    document.body.classList.remove("modal-open");
  }
}

/**
 * 
 * @param {object} mdContainer 
 * @returns 
 */
export function fireInstallAppAnswerEvent(mdContainer) {

  if (mdContainer) {
    if (!config.deferredPrompt) return;
    if (isIOS()) {
      setToLocalStorage(config.installAppKey, "1", 5);
      mdContainer.remove();
      document.querySelector(".modal-backdrop")?.remove();
      document.body.classList.remove("modal-open");
      return;
    }
    config.deferredPrompt.prompt();
    const { outcome } = config.deferredPrompt.userChoice;
    console.log('PWA install:', outcome); // accepted or dismissed
    config.deferredPrompt = null; // important!
    mdContainer.remove();
    document.querySelector(".modal-backdrop")?.remove();
    document.body.classList.remove("modal-open");
  }
}
export function fireInstallAppRefuseEvent(mdContainer) {

  if (mdContainer) {
    // don't remind user again let him after 5 hours
    setToLocalStorage(config.installAppKey, "1", 5);
    config.deferredPrompt = null; // important!
    mdContainer.remove();
    document.querySelector(".modal-backdrop")?.remove();
    document.body.classList.remove("modal-open");
  }
}
/**
 * 
 * @param {string} message 
 * @returns {string}
 */
export function cleanMessageContent(message) {
  message = message.split(/[r\\\\n]/).join('');
  // console.log(cleanStr);
  return message.replace(/[\r\n]/g, '').trim();
}
/**
 * 
 * @param {string} dateString 
 * @returns 
 */
export function formatDateOrTime(dateString) {
  // Parse the input date string
  const inputDate = new Date(dateString.replace(' ', 'T')); // Ensure proper ISO format

  // Get today's date
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset time to 00:00:00 for accurate comparison

  // Check if the input date is today
  if (
    inputDate.getFullYear() === today.getFullYear() &&
    inputDate.getMonth() === today.getMonth() &&
    inputDate.getDate() === today.getDate()
  ) {
    // If today, return the time in 12-hour format with AM/PM
    let hours = inputDate.getHours();
    const minutes = inputDate.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert to 12-hour format
    return `${hours}:${minutes} ${ampm}`;
  } else {
    // If not today, return the date in "DD - MMM" format
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const day = inputDate.getDate();
    const month = monthNames[inputDate.getMonth()];
    return `${day} ${month}`;
  }
}

/**
 *  Function to sanitize input (prevent script injection)
 * @param {string} input 
 * @returns 
 */
export function sanitizeInput(input) {
  return input.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

// 
/**
 * Function to validate email format
 * @param {string} email 
 * @returns 
 */
export function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple email regex
  return emailRegex.test(email);
}
/**
 * 
 * @param {object} img 
 * @param {number} index 
 */
export function validateImage(img, index) {
  if (img.naturalWidth > 0 && img.naturalHeight > 0) {
    //  console.log("Image loaded successfully: " + index);
  }
}
/**
 * This function deal with images designed history
 * @param {number} index 
 */
export function hideControls(index) {

  let imageDesigned = document.getElementById($`design_${index}`);
  if (imageDesigned) {
    imageDesigned.remove();
  }
  config.badImages.push(index);
  let saveIcon = document.getElementById(`save_${index}`);
  let deleteIcon = document.getElementById(`delete_${index}`);
  //let checkButton = document.getElementById(`chk_${index}`);
  let lblTitle = document.getElementById(`lbl_${index}`);
  //let fchk = document.getElementById(`fchk_${index}`);
  let img = document.getElementById(`img_${index}`);
  //fchk.remove();
  saveIcon.remove();
  deleteIcon.remove();
  //checkButton.remove();
  lblTitle.remove();
  img.remove();
  let container = document.getElementById(`design_${index}`);
  container.style = "display:none;"
}
/**
 * 
 * @param {number} index 
 * @returns 
 */
export function sanitizeImages(index) {
  let designObjects = getStoredDesigns(config.historyKey);
  for (index = 0; index < config.badImages.length; index++) {
    designObjects[config.badImages[index]].imageName = "badImage";
  }
  return designObjects;
}
/**
 * 
 * @param {object} sender 
 * @param {number} index 
 */
export function addDesign(sender, index) {
  try {
    let designObjects = sanitizeImages(index);
    // validate images which not exists because we delete it from th server
    let design = designObjects[index];
    // check if the image loaded and not written ad badImage
    if (design.imageName != "badImage") {
      let imagepath = design.host + "/images/shared/" + design.imageName;
      if (sender.checked) {
        // check if it exists or not 
        if (config.images.indexOf(imagepath) == -1) {
          config.images.push(imagepath);
        }
      } else {
        config.images.splice(config.images.indexOf(imagepath), 1);
        // check if check all button not selected
        if (document.getElementById('chkall').checked) {
          document.getElementById('chkall').checked = false;
        }
      }
    }

  } catch (e) {
    console.log(e);
  }
}
/**
 * 
 * @param {number} index 
 */
export function confirmDelete(index) {
  config.currentIndexToDelete = index;
  let deleteModal = new bootstrap.Modal(document.getElementById("deleteModal"));
  deleteModal.show();
}
/**
 * 
 * @param {string} key 
 * @param {number} index 
 */
export function removeDesignObject(key, index) {
  let items = JSON.parse(localStorage.getItem(key)) || []; // Get the array or default to empty
  if (index >= 0 && index < items.length) { // Ensure index is valid
    items.splice(index, 1); // Remove the item at the given index
    localStorage.setItem(key, JSON.stringify(items)); // Save updated array back
  } else {
    console.log("Invalid index");
  }
}
export function checkAllDesigns(sender, index) {
  try {
    let designObjects = sanitizeImages(index);
    designObjects.forEach((design, index) => {
      let currentCheckBox = document.getElementById(`chk_${index}`);
      if (currentCheckBox) {
        if (sender.checked) {
          currentCheckBox.checked = true;
          addDesign(document.getElementById(`chk_${index}`), index);
        } else {
          currentCheckBox.checked = false;
          config.images = [];
        }
      }
    });

  } catch (e) {
    console.log(e);
  }
}
export function FixAdsenseProblems() {
  const observer = new MutationObserver((mutations) => {
    // console.log("observer works..");
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        if (document.body.style.paddingTop) {
          document.body.style.paddingTop = '0';  // Reset padding shifts
        }
      }
    });
  });
  observer.observe(document.body, { attributes: true });
}

export function whenControlled() {
  if (navigator.serviceWorker.controller && deferredPrompt) {
    showInstallModal();
  } else {
    setTimeout(whenControlled, 100);
  }
}
function showInstallModal() {
  ui.createSubscribeModal("installApp", "ثبت تطبيق صمّم بنفسك", ui.createInstallAppMessage(), fireInstallAppAnswerEvent, fireInstallAppRefuseEvent);
}
/**
 *  get category url from config.categoriesUrl
 * @param {string} category 
 * @returns {string}
 */
export function getcategoryUrl(category) {
  let categoryUrl = config.categoriesUrl.find((item) => item.name === category);
  if (!categoryUrl) {
    return config.domain;
  }
  return `${config.domain}${categoryUrl?.url}/`;
}
/**
 * Handle lazy images loader
 * @param {string} className 
 */
export function handleLazyImagesLoader(className) {
  const images = document.querySelectorAll(className);

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const img = entry.target;

      ui.showLoaderContainer();

      if (img.complete) {
        ui.hideLoaderContainer();
      } else {
        img.onload = () => ui.hideLoaderContainer();
        img.onerror = () => ui.hideLoaderContainer();
      }

      observer.unobserve(img);
    });
  }, {
    threshold: 0.1
  });

  images.forEach(img => observer.observe(img));
}
export function getShareKey(designName = '') {
  if (designName.includes('moled')) return 'moled';
  if (designName.includes('adha')) return 'adha';
  if (designName.includes('ramadan')) return 'ramadan';
  if (designName.includes('newyear')) return 'newyear';
  if (designName.includes('hijri')) return 'hijri';
  return '';
}
